<template>
  <section class="section cms-text-image">
    <b-container>
      <div class="cms-text-image__banner">
        <b-row
          class="cms-text-image__row"
          :class="{ 'cms-text-image__row--reverse': reverse }"
        >
          <b-col sm="12" md="6">
            <div class="cms-text-image__text clearfix">
              <h4 v-if="title" class="black" v-html="title"></h4>
              <br v-if="title" />
              <p v-if="text" v-html="text"></p>
              <content-link
                v-if="resolved_link"
                :link="resolved_link"
                class="float-right"
              >
                <u>{{ resolved_link.label || 'Scopri di più' }}</u>
              </content-link>
            </div>
          </b-col>
          <b-col
            v-if="resolved_image"
            sm="12"
            md="6"
            class="cms-text-image__media"
          >
            <img
              :src="resolved_image.url"
              :alt="resolved_image.alt"
              class="cms-text-image__image"
            />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </section>
</template>

<script>
  /**
   * CMS `text-image` block: text with a side image.
   * Schema (props): `{ reverse, image, title, text, link }`.
   * Mirrors the original blocks/info-banner.vue component.
   */
  import { resolve_link, resolve_media } from './content-utilities';
  import ContentLink from './content-link.vue';

  export default {
    name: 'text-image',

    components: { 'content-link': ContentLink },

    props: {
      reverse: {
        type: Boolean,
        default: false,
      },
      image: {
        type: [Object, String],
        default: null,
      },
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      link: {
        type: [Object, String],
        default: null,
      },
    },

    computed: {
      resolved_image() {
        return resolve_media(this.image);
      },
      resolved_link() {
        return resolve_link(this.link);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cms-text-image {
    &__banner {
      margin: $grid-gutter-width/2;
    }

    &__row {
      background: $white;
      display: flex;
      align-items: center;
      overflow: hidden;
      border-radius: $border-radius-lg * 2;

      &--reverse {
        flex-direction: row-reverse;
      }
    }

    &__text {
      padding: $grid-gutter-width;
    }

    &__media {
      position: relative;
      min-height: 360px;
      padding: 0;
    }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
</style>
